<template>
  <div id="PSGRequest">
    <section>
      <div id="container-center">
        <h1 style="" class="title has-text-centered printTarget">解析申込み（{{analysisType}}）</h1>
        <div>
          <b-steps v-model="activeStep" :animated="true" :rounded="true" :has-navigation="false" label-position="bottom">
            <b-step-item step="1" label="利用規約" icon="comment-alert-outline" v-if="needAgree">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="home" @click.prevent="goHome">ホーム画面</b-button>
                  <b-button class="is-primary" style="float: right" icon-right="chevron-double-right" :disabled="!isChecked" @click.prevent="Forward">次へ</b-button>
                  <span>以下の利用規約に同意のうえ、申込みを行ってください。</span>
                </div>
                <div class="card-content margin-top">
                  <span style="font-size:20px;">利用規約</span>
                  <table>
                    <tr><td><textarea readonly class="cautionArea noresize" v-model="agreement"/></td></tr>
                    <tr>
                        <td>
                          <div style="text-align: center;">
                            「<a :href="getUrlPrivacyPolicy()" target="_blank" rel="noopener noreferrer">プライバシー規則</a>」は<a :href="getUrlPrivacyPolicy()" target="_blank" rel="noopener noreferrer" style="font-weight: bold;color:yellowgreen">こちら</a>を参照してください。
                          </div>
                       </td>
                    </tr>
                    <tr><td><div style="text-align: center;"></div></td></tr>
                    <tr><td><div style="text-align: center;"><b-checkbox class="cstmCheckBox" v-model="isChecked" :disabled="!canAgree">利用規約に同意のうえ、申込みを行う。</b-checkbox></div></td></tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="2" label="依頼内容" icon="pulse">
              <div id="item-contens">
                <div class="request-title">
                  <b-button v-if="needAgree" class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <b-button v-else class="is-primary" style="float:left;" icon-left="home" @click.prevent="goHome">ホーム画面 </b-button>
                  <b-button class="is-primary" style="float: right" icon-right="chevron-double-right" :disabled="!isHospitalAgree" @click.prevent="Forward">次へ</b-button>
                  <span>PSG解析依頼の情報を入力してください。</span>
                </div>
                <div class="card-content margin-top">
                  <table>
                     <tr><th>医療機関名<span class="require" v-if="isDealer || isHonsha || isAdmin || isSalesOffice"/></th>
                      <td>
                        <template v-if="isDealer || isHonsha || isAdmin || isSalesOffice">
                          <input type="text" style="width:730px;" v-model="reqParams.hospitalName" disabled class="2" name="医療機関名" validate="required"/>
                          <b-button style="margin-left:10px; width:150px; height:27px;" @click="organizationModalActive=true">医療機関選択</b-button>
                        </template>
                        <template v-else>{{reqParams.hospitalName}}</template>
                      </td>
                    </tr>
                    <tr><th>医師名</th><td><input type="text" v-model="reqParams.doctorName" maxlength="105"/></td></tr>
                    <tr><th>事務担当者名</th><td><input type="text" v-model="reqParams.clerkName" maxlength="100"/></td></tr>
                    <tr v-if="isHonsha || isAdmin || isSalesOffice"><th>コメント</th><td>{{reqParams.note}}</td></tr>
                    <template v-if="isDealer || isHonsha || isAdmin || isSalesOffice">
                      <tr><th>医療機関メールアドレス</th><td><b-checkbox class="cstmCheckBox" v-model="reqParams.isResultMailSend">解析結果のダウンロードURLを医療機関にメールで通知する。</b-checkbox></td></tr>
                      <tr v-if="reqParams.isResultMailSend"><th></th><td><input type="text" v-model="reqParams.hospitalMail" placeholder="例）example@example.com" class="2" name="医療機関メールアドレス" validate="mail|required"></td></tr>
                    </template>
                    <tr><th>解析方法<span class="require" /></th>
                      <td>
                        <select id="analysisMethod" v-model="reqParams.analysisMethod" @change="changeanAlysisMethod" :disabled="!reqParams.hospitalName || analysisMethodList.length <= 1" class="2" name="解析方法" validate="required">
                          <option v-for="method in analysisMethodList" :value="method.value" :key="method.value">{{ method.label1 }}</option>
                        </select>
                      </td>
                    </tr>
                    <tr v-if="reqParams.hospitalName && analysisMethodList.length <= 1"><th></th><td>現在、ご契約済の解析方法はございません。営業担当にお問い合わせください。</td></tr>
                    <tr><th>SleepwareG3のバージョン<span class="require" v-if="requireG3"/></th>
                      <td><select v-model="reqParams.sleepwareG3Version" name="SleepwareG3のバージョン" class="2" :validate="`${requireG3 ? 'required' : ''}`">
                        <option v-for="sleepwareG3 in sleepwareVersionList" :value="sleepwareG3.value" :key="sleepwareG3.value">{{ sleepwareG3.label1 }}</option>
                        </select></td>
                    </tr>
                    <tr>
                      <th>レポート形式<span class="require" /></th>
                      <td>
                        <select v-model="reqParams.reportFormat" class="2" name="レポート形式" validate="required">
                          <option v-for="report in reportFormatList" :value="report.value" :key="report.value">{{ report.label1 }}</option>
                        </select>
                      </td>
                    </tr>
                    <tr><th>最短返却可能日</th><td>{{reqParams.shortestReturnDate}}</td></tr>
                    <tr><th>お急ぎ便利用</th><td><b-checkbox class="cstmCheckBox" v-model="urgentConvenience" @input="useExpressDelivery">お急ぎ便を利用する。</b-checkbox></td></tr>
                    <tr id="tr_urgency_caution" v-if="urgentConvenience">
                      <th></th>
                      <td>
                        <div class="urgency_caution">
                          ・お急ぎ便は緊急の場合のみご利用ください。 <br />
                          ・お急ぎ便を指定した場合でもご希望の返却希望日に沿えない場合がございます。<br />
                          ・上記に同意される場合、下記チェックと理由をご記入ください。
                        </div>
                        お急ぎ便利用理由<span class="require"/><textarea v-model="reqParams.urgentConvenienceReasons" class="2" name="お急ぎ便利用理由" validate="required" maxlength="256" style="resize:vertical;max-width:100%;"></textarea>
                        <b-checkbox value="false" class="cstmCheckBox" v-model="precautionsAgree" id="precautionsAgree" @input="agreeExpressDeliveryPrecautions">お急ぎ便利用時の注意事項に同意する。<span class="require" /></b-checkbox><br /><br />
                      </td>
                    </tr>
                    <tr><th>返却希望日<span class="require" /></th><td><input type="date" v-model="reqParams.returnDate" style="width:150px;" class="2" name="返却希望日" validate="required|date" disabled/><a @click="officeCalenderActive = true"><b-icon icon="calendar-cursor"></b-icon></a></td></tr>
                    <tr><th></th>
                      <td>
                        <div>※17時以降のお申し込みは、翌営業日受付となります。</div>
                        <div class="urgency_caution" v-if="winterHoliday">
                          12月22日(木)以降の標準マニュアル解析・簡易検査解析、12月26日(月)以降のExpert Review解析において、<br />
                          年内の返却をご希望の場合にはお急ぎ便をご利用ください。年明けの受付開始日は1月6日(金)となります。
                        </div>
                      </td>
                    </tr>
                    <tr><th>備考</th><td><textarea v-model="reqParams.biko" maxlength="256" style="resize:vertical;max-width:100%;"></textarea></td></tr>
                    <tr><th class="deliverySlip_label">納品書</th>
                      <td>
                        <div>
                          <b-radio class="td_radio deliverySlip_radio" name="deliverySlip" v-model="reqParams.deliverySlip" :native-value="true">必要</b-radio>
                          <b-radio class="td_radio deliverySlip_radio" name="deliverySlip" v-model="reqParams.deliverySlip" :native-value="false">不要</b-radio>
                        </div>
                      </td>
                    </tr>
                    <tr><th>デモ</th><td><b-checkbox class="cstmCheckBox" v-model="reqParams.demo" @input="setAnalysisMethodList">デモ(トライアル)</b-checkbox></td></tr>
                    <template v-if="isDealer">
                      <tr/>
                      <tr>
                        <th/><td><b-checkbox class="cstmCheckBox" v-model="isHospitalAgree">申請者が{{analysisType}}の申込みを行うことについて、該当医療機関の同意を取得しています。</b-checkbox></td>
                      </tr>
                    </template>
                  </table>
                </div>
                <!-- <div class="card-content margin-top">
                    <table>
                      <tr>
                        <th style="vertical-align:top;">注意事項</th>
                        <td v-if='psgKind=="full"'>※注1 Sleepware G3のバージョンについて<br>&emsp;バージョンのご指定がない場合は、最新バージョンにて返却となります。</td>
                        <td v-if='psgKind=="easy"'>※注1 解析ソフトのバージョンについて<br>&emsp;Sleepware G3バージョンのご指定がない場合は、最新バージョンにて返却となります。(Alice 使用時)<br>&emsp;スマートウォッチの解析はすべて最新のバージョンになります。</td>
                      </tr>
                    </table>
                </div> -->
              </div>
            </b-step-item>
            <b-step-item step="3" label="患者情報設定" icon="account">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float: left" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <span>患者の情報を入力してください。</span>
                  <b-button class="is-primary" style="float: right" icon-right="chevron-double-right" @click.prevent="Forward">次へ</b-button>
                </div>
                <div class="card-content margin-top">
                  <table>
                    <tr><th>診察券ID（患者ID）<span class="require"/></th><td><input type="text" v-model="reqParams.patientId" @input="reqParams.patientId = $event.target.value.replace(/^\s+/, '')" maxlength="50" class="3" name="診察券ID（患者ID）" validate="required" /></td></tr>
                    <tr><th>患者名<span class="require" /></th><td><input type="text" v-model="reqParams.patientFamilyName" style="margin-right: 5px; width: 446px !important;" class="3" placeholder="姓" name="患者名(姓)" validate="required|patientName" maxlength="49"/><input type="text" v-model="reqParams.patientFirstName" style="width: 446px !important;" class="3" placeholder="名" name="患者名(名)" validate="required|patientName" maxlength="49"/></td></tr>
                    <tr><th>患者名（カナ）<span class="require"/></th><td><input type="text" v-model="reqParams.patientFamilyNameKana" style="margin-right: 5px; width: 446px !important;" class="3" placeholder="セイ ※匿名の場合は「トクメイ」と入力してください。" name="患者名カナ(セイ)" validate="required|patientNameKana" maxlength="49"/><input type="text" v-model="reqParams.patientFirstNameKana" style="width: 446px !important;" class="3" placeholder="メイ ※匿名の場合は「トクメイ」と入力してください。" name="患者名カナ(メイ)" validate="required|patientNameKana" maxlength="49"/></td></tr>
                    <tr><th>性別<span class="require"/></th>
                      <td>
                        <div>
                          <b-radio class="td_radio genderCheck" name="gender" v-model="reqParams.gender" native-value="-">-</b-radio>
                          <b-radio class="td_radio genderCheck" name="gender" v-model="reqParams.gender" native-value="男">男</b-radio>
                          <b-radio class="td_radio genderCheck" name="gender" v-model="reqParams.gender" native-value="女">女</b-radio>
                        </div>
                      </td>
                    </tr>
                    <tr><th>生年月日<span class="require"/></th><td><input type="date" v-model="reqParams.birthday" :input="inputBirthday()" class="3" name="生年月日" validate="date|birthDay" :max="yyyy_hyp_MM_hyp_dd(new Date())" style="width:150px;" id="birthDay"/><span v-if="reqParams.birthday" style="margin-left:10px;">{{reqParams.japaneseCalendar}}</span></td></tr>
                    <tr><th>年齢</th><td><input type="text" disabled v-model="reqParams.age"/></td></tr>
                    <tr><th>身長</th><td><input type="text" v-model="reqParams.height" :input="calcBmi()" class="3" name="身長" validate="double" maxlength="5"/></td></tr>
                    <tr><th>体重</th><td><input type="text" v-model="reqParams.weight" :input="calcBmi()" class="3" name="体重" validate="double" maxlength="5"/></td></tr>
                    <tr><th>BMI</th><td><input type="text" disabled v-model="reqParams.bmi"/></td></tr>
                    <tr><th>基礎疾患・合併症</th><td><input type="text" v-model="reqParams.basicIllnessComplications" maxlength="256"/></td></tr>
                    <tr><th>投薬状況</th><td><input type="text" v-model="reqParams.dosingStatus" maxlength="256"/></td></tr>
                    <tr><th>主訴</th><td><input type="text" v-model="reqParams.chiefComplaint" maxlength="256"/></td></tr>
                    <tr><th>備考</th><td><textarea v-model="reqParams.patientBiko" maxlength="256" style="resize:vertical;max-width:100%;"/></td></tr>
                  </table>
                </div>
                <div class="card-content margin-top">
                    <table>
                      <tr>
                        <th style="vertical-align:top;">注意事項</th>
                        <td >※注2 小児ルールについて<br>&emsp;13歳未満の場合は、睡眠段階/呼吸イベントともにAASM小児ルールを採用します。<br>&emsp;13歳未満でも成人ルールを採用される場合は、追加指示を備考欄にご記入ください。
                        <div v-if="reqParams.fullFlag">&emsp;スリーププロファイラー解析、ER解析は年齢に関わらず成人ルールでの解析となります。</div></td></tr>
                    </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="4" label="解析データ情報" icon="file-find">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float: left" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <span>解析を依頼するデータの情報を入力してください。</span>
                  <b-button class="is-primary" style="float: right" icon-right="chevron-double-right" @click.prevent="Forward">次へ</b-button>
                </div>
                <div class="card-content margin-top">
                  <table>
                    <tr><th>検査目的</th>
                      <td>
                        <select v-model="reqParams.analysisDataInfo.inspectionPurpose">
                          <option v-for="inspectionPurpose in inspectionPurposeList" :value="inspectionPurpose.value" :key="inspectionPurpose.value">{{ inspectionPurpose.label1 }}</option>
                        </select>
                      </td>
                    </tr>
                    <tr><th>検査目的（その他）</th><td><input type="text" v-model="reqParams.analysisDataInfo.inspectionPurposeMemo" maxlength="256"/></td></tr>
                    <tr><th>設定圧</th><td><input type="text" v-model="reqParams.analysisDataInfo.setPressure" maxlength="256"/></td></tr>
                    <tr><th>消灯時刻</th><td>
                        <select style="width: 50px; margin-right: 5px" v-model="offTimeHour" @change="changeOffTime">
                          <option></option><option>00</option><option>01</option><option>02</option><option>03</option><option>04</option><option>05</option><option>06</option><option>07</option><option>08</option><option>09</option>
                          <option>10</option><option>11</option><option>12</option><option>13</option><option>14</option><option>15</option><option>16</option><option>17</option><option>18</option><option>19</option>
                          <option>20</option><option>21</option><option>22</option><option>23</option>
                        </select>時
                        <select style="width: 50px; margin-right: 5px" v-model="offTimeMinutes" @change="changeOffTime">
                          <option></option><option>00</option><option>01</option><option>02</option><option>03</option><option>04</option><option>05</option><option>06</option><option>07</option><option>08</option><option>09</option>
                          <option>10</option><option>11</option><option>12</option><option>13</option><option>14</option><option>15</option><option>16</option><option>17</option><option>18</option><option>19</option>
                          <option>20</option><option>21</option><option>22</option><option>23</option><option>24</option><option>25</option><option>26</option><option>27</option><option>28</option><option>29</option>
                          <option>30</option><option>31</option><option>32</option><option>33</option><option>34</option><option>35</option><option>36</option><option>37</option><option>38</option><option>39</option>
                          <option>40</option><option>41</option><option>42</option><option>43</option><option>44</option><option>45</option><option>46</option><option>47</option><option>48</option><option>49</option>
                          <option>50</option><option>51</option><option>52</option><option>53</option><option>54</option><option>55</option><option>56</option><option>57</option><option>58</option><option>59</option>
                        </select>分
                      </td>
                    </tr>
                    <tr>
                      <th>点灯時刻</th>
                      <td>
                        <select style="width: 50px; margin-right: 5px" v-model="onTimeHour" @change="changeOnTime">
                          <option></option><option>00</option><option>01</option><option>02</option><option>03</option><option>04</option><option>05</option><option>06</option><option>07</option><option>08</option><option>09</option>
                          <option>10</option><option>11</option><option>12</option><option>13</option><option>14</option><option>15</option><option>16</option><option>17</option><option>18</option><option>19</option>
                          <option>20</option><option>21</option><option>22</option><option>23</option>
                        </select>時
                        <select style="width: 50px; margin-right: 5px" v-model="onTimeMinutes" @change="changeOnTime">
                          <option></option><option>00</option><option>01</option><option>02</option><option>03</option><option>04</option><option>05</option><option>06</option><option>07</option><option>08</option><option>09</option>
                          <option>10</option><option>11</option><option>12</option><option>13</option><option>14</option><option>15</option><option>16</option><option>17</option><option>18</option><option>19</option>
                          <option>20</option><option>21</option><option>22</option><option>23</option><option>24</option><option>25</option><option>26</option><option>27</option><option>28</option><option>29</option>
                          <option>30</option><option>31</option><option>32</option><option>33</option><option>34</option><option>35</option><option>36</option><option>37</option><option>38</option><option>39</option>
                          <option>40</option><option>41</option><option>42</option><option>43</option><option>44</option><option>45</option><option>46</option><option>47</option><option>48</option><option>49</option>
                          <option>50</option><option>51</option><option>52</option><option>53</option><option>54</option><option>55</option><option>56</option><option>57</option><option>58</option><option>59</option>
                        </select>分
                      </td>
                    </tr>
                    <tr>
                      <th>消灯点灯に関する追加指示</th>
                      <td>
                        <select v-model="reqParams.analysisDataInfo.offTimeAdditionalInstructions">
                          <option v-for="offTimeAdditional in offTimeAdditionalInstructionsList" :value="offTimeAdditional.value" :key="offTimeAdditional.value">{{ offTimeAdditional.label1 }}</option>
                        </select>
                      </td>
                    </tr>
                    <tr><th>備考</th><td><textarea v-model="reqParams.analysisDataInfo.biko" maxlength="256" style="resize:vertical;max-width:100%;"></textarea></td></tr>
                    <tr><th>添付データ<span class="require" /></th>
                      <td>
                        <div class="hsrReq_upload_area" @dragenter="dragEnter">
                          <span class="upload_span">ここに添付する解析データを「フォルダごと、ドラッグアンドドロップ」してください。<br>「ファイルを追加」から添付する場合は、事前に検査データを圧縮の上、添付ください。</span>
                        </div>
                      </td>
                      <b-modal :active.sync="isUpdateModal" has-modal-card  >
                        <div class="modal-card uploadModal" 
                          @dragleave="dragLeave"
                          @drop.prevent="fileDorop"
                        >
                            ここに解析データファイルをドロップします。
                        </div>
                      </b-modal>
                    </tr>
                    <tr><th></th>
                      <td>
                        <b-upload v-model="upButtonFile"  class="file-label" v-on:input="addUploadfile" multiple>
                          <span class="file-cta">
                            <span class="file-label">ファイルを追加</span>
                          </span>
                        </b-upload>
                      </td>
                    </tr>
                    <tr><th></th><td>
                        <table>
                          <template v-for="(upfile,index) of upFiles">
                            <tr :key="index">
                              <td style="width: 20px"><b-icon icon="paperclip" /></td><td style="width: 400px">{{upfile.path}}</td><td><a @click="deleteUpfile(index)"><b-icon icon="delete-forever-outline " /></a></td></tr>
                          </template>
                        </table>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="card-content margin-top">
                    <table>
                      <tr>
                        <th style="vertical-align:top;">注意事項</th>
                        <td v-if='psgKind=="full"'>※注3 消灯・点灯の設定について<br>
                            &emsp;①消灯・点灯の入力が無い場合<br>
                            &emsp;&emsp;・入眠を消灯とします。睡眠潜時が0.0分と算出されることをご了承ください。<br>
                            &emsp;&emsp;・タイトレーション検査時の治療器の作動時間や画像を参考にします。<br>
                            &emsp;&emsp;・スリーププロファイラー解析においては、自動判定により波形が安定した箇所を消灯とします。<br>
                            &emsp;②入力されている消灯時刻前・点灯時刻以降に睡眠が認められた場合は脳波視察判定を優先します。<br>
                            &emsp;&emsp;・指定の消灯・点灯時刻を厳守する場合は「解析データ情報」画面の消灯点灯の追加指示にてお選びください。<br>
                        </td>
                        <td v-if='psgKind=="easy"'>※注3 消灯・点灯の設定について<br>
                            &emsp;①消灯時刻の記載がない場合<br>
                            &emsp;&emsp;・測定開始または波形が安定した時刻を消灯とします。<br>
                            &emsp;②消灯時刻前・点灯時刻以降に呼吸イベントが見られた場合<br>
                            &emsp;&emsp;・呼吸イベントの判定を優先します。<br>
                            ※注4 複数夜記録の場合<br>
                            &emsp;複数夜記録した場合、重症度の高い一晩を解析します。全夜分の解析をご希望の場合はその旨を備考欄にご記入ください。
                        </td>
                      </tr>
                    </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="5" label="申込み" icon="cloud-upload">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float: left" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <span>以下の申込み内容を確認のうえ、下部の「申込みを完了する」ボタンを押下してください。</span>
                </div>
                <!--　PSG申込み詳細 -->
                <psgRequestDetail ref="comfirmDetails" :key="reset" v-bind:data="reqParams"/>
                <b-button class="is-primary" style="margin-top:5px; width:250px;" :disabled="compleateFlg" @click="requestPSG">申込みを完了する</b-button>
              </div>
            </b-step-item>
            <b-step-item step="6" label="完了" icon="check" :type="{ 'is-success': true }">
              <section class="unPrintTarget">
                <div class="request-title"><span>PSG解析の申込みを受け付けました。</span></div>
                <div class="request-title" v-if="needAgree"><span style="color:red;">翌営業日までに登録済みメールアドレスへ申し込み完了メールが送信されます。</span></div>
                <div class="margin-top">
                  <b-button class="backbutton is-primary" @click="back">戻る</b-button>
                  <b-button class="printbutton is-primary" icon-left="printer" @click="print">印刷</b-button>
                </div>
              </section>
              <section class="printTarget printMargin">
                <div id="item-contens">
                  <div class="card-content margin-top">
                    <table>
                      <tr><th>受付日時</th><td>{{requestDate}}</td></tr>
                      <tr><th>受付番号</th><td>{{receiptNumber}}</td></tr>
                    </table>
                  </div>
                </div>
                <psgRequestDetail ref="finishDetails" :key="reset" v-bind:data="reqParams"/>
              </section>
            </b-step-item>
          </b-steps>
        </div>
      </div>
    </section>
    <b-modal :active.sync="organizationModalActive" has-modal-card>
      <organizationSelectModal v-if="isHonsha || isAdmin || isSalesOffice" :selectRole="[role.role_hospital]" :selectStatus="extUserStatus.registed" :serviceId="serviceId" title="医療機関選択" labelForOrg="医療機関名" @select="setOrganization"></organizationSelectModal>
      <facilitySelectModal v-if="isDealer" :dealerId="userId" @select="setfacility"></facilitySelectModal>
    </b-modal>
    <b-modal :active.sync="officeCalenderActive" has-modal-card>
      <officeCalenderModal :miniday="new Date(reqParams.shortestReturnDate)" @select="setReturnDate"></officeCalenderModal>
    </b-modal>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";
import {consentStatement} from "@/components/mock/base/const.js";
import {UploadType} from "@/components/mock/base/const.js";
import {choicesType} from "@/components/mock/base/const.js";
import {extUserStatus} from "@/components/mock/base/const.js";
import {analysisMethod} from "@/components/mock/base/const.js";
import {service} from "@/components/mock/base/const.js";
import psgRequest from "@/components/mock/common/PSGRequestDetail";
import OrganizationSelectModal from "@/components/mock/philips/common/OrganizationSelectModal";
import FacilitySelectModal from "@/components/mock/philips/common/FacilitySelectModal";
import OfficeCalenderModal from "@/components/mock/guest/OfficeCalenderModal";

const HOLIDAY_JP = require("@holiday-jp/holiday_jp");
const PH_HOLIDAYS = require('@/components/mock/base/philipsHollday.json');
const closingTime = 17;

export default {
  name: "PSGRequest",
  methods: {
    Backward: function() {
      this.activeStep -= 1;
    },
    Forward: async function(event) {
      // バリデーションチェック
      var stepItems = document.getElementsByClassName("step-item")
      var target
      for(var item of stepItems){
        if(item.getAttribute("style") != "display: none;"){
          target = item
        }
      }
      var activeStep = target ? target.getAttribute("step") : ""
      if(activeStep){
        var elements = document.getElementsByClassName(activeStep)
        var result = this.selfMadeValidation(elements)
        var errMsg = result.msg
        if(activeStep+""=="2" && this.reqParams.urgentConvenience+"" == "true"){
          var element = document.getElementById("precautionsAgree");
          element.children[1].style["border-color"] = "";
          if(this.precautionsAgree+"" != "true"){
            errMsg = errMsg + "お急ぎ便利用時の注意事項同意チェックは必須項目です。\n"
            element.children[1].style["border-color"] = "red";
          }
        }else if (activeStep+""=="3"){
          this.$set(this.reqParams, "patientName", this.reqParams.patientFamilyName + " " + this.reqParams.patientFirstName)
          this.$set(this.reqParams, "patientNameKana", this.reqParams.patientFamilyNameKana + " " + this.reqParams.patientFirstNameKana)

          var genderElements = document.getElementsByClassName("genderCheck");
          for(let genderElement of genderElements){
            let genderCheckElements = genderElement.getElementsByClassName("check")
            genderCheckElements[0].style["border-color"] = "";
          }
          if(!this.reqParams.gender){
            errMsg = errMsg + "性別は必須項目です。\n"
            for(let genderElement of genderElements){
              let genderCheckElements = genderElement.getElementsByClassName("check")
              genderCheckElements[0].style["border-color"] = "red";
            }
          }
          var birthdayElement = document.getElementById("birthDay");
          birthdayElement.style["border-color"] = "";
          if(!this.reqParams.birthday){
            errMsg = errMsg + "生年月日は必須項目です。\n"
            birthdayElement.style["border-color"] = "red";
          }
        }else if (activeStep+""=="4"){
          if (activeStep+""=="4" && this.upFiles.length==0){
            errMsg = errMsg + "添付データが選択されていません。\n"
          }else{
            let nameList = this.upFiles.map(item => item['path']);
            for(let i =0; i < nameList.length; i++){
              if(nameList[i].startsWith("/")){
                //フォルダの場合はzip名にしてチェック
                nameList[i] = nameList[i].replace("/", "") + ".zip"
              }
            }
            const setElements = new Set(nameList);
            if (setElements.size !== nameList.length) {
              errMsg = errMsg + "添付データの重複しているファイルが存在します。\n"
            } else {
              let sizeOK = await this.checkUploadFileSize(this.upFiles);
              if(!sizeOK){
                errMsg = errMsg + "2GBを超えるファイルはアップロードできません。\n"
              }
            }
          }
          if((this.offTimeHour || this.offTimeMinutes ) && !( this.offTimeHour && this.offTimeMinutes )){
            errMsg = errMsg + "消灯時刻を正しく選択してください。\n"
          }
          if((this.onTimeHour || this.onTimeMinutes ) && !( this.onTimeHour && this.onTimeMinutes )){
            errMsg = errMsg + "点灯時刻を正しく選択してください。\n"
          }          
        }
        if(result.isError){
          this.showErrorMessage(errMsg)
        }else if (errMsg != ""){
          this.showErrorMessage(errMsg)
        }else{
          this.activeStep += 1;
        }
      }
    },
    inputBirthday: function(){
      var age = this.getAge(this.reqParams.birthday)
      if(!isNaN(Number(age))){
        this.reqParams.age = age < 0 ? 0 : age
        const date = new Date(this.reqParams.birthday);
        const options = {era: 'long'};
        this.reqParams.japaneseCalendar  = "【"+this.getJapaneseCalendar(date)+"】"
      }else{
        this.reqParams.age = ""
      }
    },
    calcBmi: function(){
      var weight = this.reqParams.weight
      var height = this.reqParams.height
      if(!weight || !height || weight==0 || height==0){
        this.reqParams.bmi = ""
        return
      }
      // 身長(cm)をメートルに換算する
      height /= 100;
      // BMIを計算する：体重 ÷ (身長 m × 身長 m)
      var bmi = weight / (height * height);
      // 小数点第2位で四捨五入
      bmi = bmi.toFixed(1)
      // BMIをセット
      this.reqParams.bmi = bmi
    },
    changeOffTime: function(){
      if(this.offTimeHour && this.offTimeMinutes){
        this.reqParams.analysisDataInfo.offTime = this.offTimeHour + ":" + this.offTimeMinutes;
      } else {
        this.reqParams.analysisDataInfo.offTime = "";
      }
    },
    changeOnTime: function(){
      if(this.onTimeHour && this.onTimeMinutes){
        this.reqParams.analysisDataInfo.onTime = this.onTimeHour + ":" + this.onTimeMinutes;
      } else {
        this.reqParams.analysisDataInfo.onTime = "";
      }
    },
    changeanAlysisMethod() {
      this.reqParams.shortestReturnDate = this.calculateShortestReturnDate();
      this.isRequireForG3();
    },
    requestPSG: async function() {
      if(!this.finallyCheckReturnDate()) {
        return false;
      };
      var messsage =
        this.analysisType +
        "の解析を申込みます。<br/>申込み内容に間違いがないことを確認して「OK」ボタンを押してください。";
      this.$dialog.confirm({
        title: "申込み確認",
        message: messsage,
        cancelText: "修正する",
        onConfirm: async () => {
          this.compleateFlg = true
          try{
            // WebAPI Call
            let _this = this;
            let isApplicationSuccess = false;
            await this.apiCall(
              function(client){
                var obj = JSON.parse(JSON.stringify(_this.reqParams));
                obj.patientId = obj.patientId ? obj.patientId.replace(/^\s+/, "") : obj.patientId
                obj.returnDate = obj.returnDate.replace(/-/g, "/")
                obj.birthday = obj.birthday ? obj.birthday.replace(/-/g, "/") : ""
                obj.age = obj.age + ""
                obj.bmi = obj.bmi + ""
                obj.belongsId = _this.belongsId
                if (!obj.isResultMailSend) {
                  obj.hospitalMail = _this.defaultMail
                }
                // クイックオーダーのロジックを追加
                if(_this.isApplicationValid){
                  obj.preReceiptNumber = _this.preReceiptNumber;
                  obj.preKind = _this.preKind
                }
                return client.apis.externalPsg.setPsgApplicationPOST({
                  body:obj
                });
              },
              function(result){
                  _this.requestDate = result.obj.requestDate
                  _this.receiptNumber = result.obj.receiptNumber
                  isApplicationSuccess = true;
              },
              function(result) {
                _this.showErrorMessage(result);
                isApplicationSuccess = false;
              },
            );
            //申請が成功したらファイルをアップロードする
            if(isApplicationSuccess){
              this.multipleUpload(this.upFiles ,this.receiptNumber, this.UploadType.psg_data, "")
              .then(result => {
                _this.finishPsgApplication();
              }).catch(error =>{
                _this.showErrorMessage("ファイルアップロードに失敗した為、申込みをキャンセルしました。<br>再度実行してください。");
              });
            }
          }finally {
            this.compleateFlg = false;
          }
        } 
      });
    },
    finishPsgApplication: function() {
      let _this = this;
      this.apiCall(
        function(client){
          return client.apis.externalPsg.finishPsgApplicationPOST({
            body:{receiptNumber:_this.receiptNumber}
          });        
        },
        function(result){
          _this.showMessage("登録が完了しました。");
          _this.jumpToTop();
          _this.$refs.finishDetails.getDetail(_this.receiptNumber); //子コンポーネントに更新を伝達
          _this.activeStep += 1;
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    back: function() {
      // 転院紹介の場合
      if(this.preReceiptNumber) {
        this.$router.push({ path: "/guest/kensaMenu" });
      }else{
        this.$router.go(-1);
      }
    },
    goHome: function() {
      if (this.userInfo.belongsId) {
        this.$router.push({ path: "/guest/kensaMenu" });
      } else {
        this.back();
      }
    },
    setOrganization: async function(organizationInfo){
      this.reqParams.belongsId = organizationInfo.id + "";
      this.reqParams.hospitalName = organizationInfo.orgName;
      this.reqParams.note = organizationInfo.note;
      if (!this.belongsId || this.belongsId != organizationInfo.id) {
        // 代理申込時
        this.belongsId = organizationInfo.id
      }
      
      if(!this.reqParams.hospitalMail){
        this.reqParams.hospitalMail = organizationInfo.mail
        this.defaultMail = organizationInfo.mail
      }

      // 見積りコードが紐づいた解析方法を取得・設定
      await this.getChoicesListLinkedEstimate();

      // 前回申込み情報の取得
      this.prevPsgSearchParam.belongsId = this.belongsId
      await this.getPreviousApplication()
    },
    setfacility: async function(facility){
      this.reqParams.institutionId = facility.id + "";
      this.reqParams.hospitalName = facility.orgName;

      // 見積りコードが紐づいた解析方法を取得・設定
      await this.getChoicesListLinkedEstimate();

      // 前回申込み情報の取得
      this.prevPsgSearchParam.institutionId = facility.id
      await this.getPreviousApplication()
    },
    getChoicesListLinkedEstimate: function() {
      var excuteApi = this.getChoicesListLinkedEstimatePOST;
      var successCallBack = this.getChoicesListLinkedEstimatePOSTSuccess;
      var errorCallBack = this.getChoicesListLinkedEstimatePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getChoicesListLinkedEstimatePOST: function(client){
      let belongId = this.reqParams.belongsId? this.reqParams.belongsId: this.belongsId
      let institutionId = this.reqParams.institutionId? this.reqParams.institutionId: 0

      return client.apis.apiCommon.getChoicesListLinkedEstimatePOST({
        body: {
          belongId: belongId,
          institutionId: institutionId
        }
      });
    },
    getChoicesListLinkedEstimatePOSTSuccess: function(result) {
      //解析方法リストをAPIからの取得値から抽出
      this.analysisMethodListLinkedEstimate = result.obj.filter(data => { return data.choicesType == this.choicesType.psgMethod });
      this.analysisMethodListLinkedEstimate = this.analysisMethodListLinkedEstimate.filter( (element) => {
        if(this.psgKind=="full"){
          return element.label3 == "フルPSG"
        }else{
          return element.label3 == "簡易PSG"
        }
      });
      this.analysisMethodListLinkedEstimate.unshift({})
      this.setAnalysisMethodList(this.reqParams.demo)
    },
    getChoicesListLinkedEstimatePOSTError: function(result){
      this.showErrorMessage(result);
    },
    setAnalysisMethodList: function(isDemo){
      if(this.reqParams.hospitalName){
        if(isDemo){
          // 選択肢マスタの解析方法を設定
          this.analysisMethodList = this.getChoiceList(this.choicesType.psgMethod, false);
          this.analysisMethodList = this.analysisMethodList.filter( (element) => {
            if(this.psgKind=="full"){
              return element.label3 == "フルPSG"
            }else{
              return element.label3 == "簡易PSG"
            }
          });
          this.analysisMethodList.unshift({})
        } else {
          // 見積りコードが紐づいている解析方法を設定
          this.analysisMethodList = this.analysisMethodListLinkedEstimate
        }
        this.changeanAlysisMethod()
      }
    },
    setReturnDate: function(selectDate){
      this.reqParams.returnDate = selectDate
      this.officeCalenderActive = false;
      console.log(this.reqParams.returnDate)
      this.reset += 1;
    },

    print: function(){
      window.print();
    },
    dragEnter: function() {
      this.isUpdateModal = true;
    },
    dragLeave: function() {
      console.log("dragLeave")
      this.isUpdateModal = false;
    },
    fileDorop: async function(event) {
      console.log("fileDorop")
      for(let i =0 ; i < event.dataTransfer.items.length; i++){
        const item = event.dataTransfer.items[i];
        const entry = item.webkitGetAsEntry();
        let path = entry.name;
        if(entry.isDirectory){
          path = entry.fullPath;
        }
        this.upFiles.push({ file: entry, path: path });
        this.reqParams.analysisDataInfo.attachedDataFileList.push({ name: path });
      }
      this.$refs.comfirmDetails.updateAattachedDataFileList(); //子コンポーネントに更新を伝達
      this.isUpdateModal = false;
    },

    addUploadfile: function(){
      for(let upFile of this.upButtonFile){
        this.upFiles.push({ file: upFile, path: upFile.name })
        this.reqParams.analysisDataInfo.attachedDataFileList.push({  name: upFile.name });
      }
      this.$refs.comfirmDetails.updateAattachedDataFileList(); //子コンポーネントに更新を伝達
      this.upButtonFile = [];
    },
    deleteUpfile: function(index){
      this.upFiles.splice(index, 1);
      this.reqParams.analysisDataInfo.attachedDataFileList.splice(index, 1);
      this.$set(this.reqParams.analysisDataInfo,"attachedDataFileList",this.reqParams.analysisDataInfo.attachedDataFileList)
      this.$refs.comfirmDetails.updateAattachedDataFileList(); //子コンポーネントに更新を伝達
    },
    getAgreementStr: async function() {
      var excuteApi = this.getConsentStatementPOST;
      var successCallBack = this.getConsentStatementPOSTSuccess;
      var errorCallBack = this.getConsentStatementPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getConsentStatementPOST: function(client) {
      var type = this.consentStatement.psg_hospital;
      if(this.isDealer){
        type = this.consentStatement.psg_dealer;
      }
      return client.apis.apiCommon.getConsentStatementPOST({
         body: {
           type: type
         } 
      });
    },
    getConsentStatementPOSTSuccess: function(result) {
      if(result.body.contents != ""){
        this.agreement = result.body.contents;
        this.canAgree = true;
      } else {
        this.agreement = "利用規約が登録されていません。";
      }

    },
    getConsentStatementPOSTError: function(result) {
      this.agreement == "利用規約を取得できませんでした。";
    },
    getChoicesList: async function() {
      this.analysisMethodList = this.getChoiceList(this.choicesType.psgMethod, false);
      this.analysisMethodList = this.analysisMethodList.filter( (element) => {
        if(this.psgKind=="full"){
          return element.label3 == "フルPSG"
        }else{
          return element.label3 == "簡易PSG"
        }
      });
      this.sleepwareVersionList = this.getChoiceList(this.choicesType.sleepwareG3Ver, false);
      let reportFormatChoice = this.getChoiceList(this.choicesType.psgReportFormat, false);
      for(let choice of reportFormatChoice){
        if( (this.psgKind=="full" && choice.label3 == "フルPSG")
          || (this.psgKind!="full" && choice.label3 == "簡易PSG")
        )
        this.reportFormatList.push(choice)
      }
      this.inspectionPurposeList = this.getChoiceList(this.choicesType.inspectionPurpose, false);
      this.offTimeAdditionalInstructionsList = this.getChoiceList(this.choicesType.turnOnOff, false);

      this.analysisMethodList.unshift({})
      this.sleepwareVersionList.unshift({})
      this.reportFormatList.unshift({})
      this.inspectionPurposeList.unshift({})
      this.offTimeAdditionalInstructionsList.unshift({})
    },
    getPreviousApplication: async function() {
      var excuteApi = this.getPreviousApplicationDetailsPOST;
      var successCallBack = this.getPreviousApplicationDetailsPOSTSuccess;
      var errorCallBack = this.getPreviousApplicationDetailsPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getPreviousApplicationDetailsPOST: function(client) {
      return client.apis.apiCommon.getPreviousApplicationDetailsPOST({
        body: this.prevPsgSearchParam
      });
    },
    getPreviousApplicationDetailsPOSTSuccess: function(result) {
      this.reqParams.doctorName = result.body.doctorName
      this.reqParams.analysisMethod = result.body.analysisMethod
      this.reqParams.sleepwareG3Version = result.body.sleepwareG3Version
      this.reqParams.reportFormat = result.body.reportFormat
      this.reqParams.shortestReturnDate = this.calculateShortestReturnDate();
      this.isRequireForG3();
    },
    getPreviousApplicationDetailsPOSTError: function(result) {
      // 取得失敗時
    },
    getApplication: async function() {
      if(this.preKind == 'hst') {
        var excuteApi = this.getHstRequestDetailPOST;
        var successCallBack = this.getHstRequestDetailPOSTSuccess;
        var errorCallBack = this.getHstRequestDetailPOSTError;
        // WebAPI Call
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      } else if (this.preKind == 'psg') {
        var excuteApi = this.getAnalysisDetailPOST;
        var successCallBack = this.getAnalysisDetailPOSTSuccess;
        var errorCallBack = this.getAnalysisDetailPOSTError;
        // WebAPI Call
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      }
        else if (this.preKind == 'holter') {
        var excuteApi = this.getHolterRequestDetailPOST;
        var successCallBack = this.getHolterRequestDetailPOSTSuccess;
        var errorCallBack = this.getHolterRequestDetailPOSTError;
        // WebAPI Call
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      }
    },
    getHstRequestDetailPOST: function(client) {
      return client.apis.internalHst.getHstRequestDetailPOST({
        body:{
          receiptNumber:this.preReceiptNumber,
        }
      });
    },
    getHstRequestDetailPOSTSuccess: function(result) {
      this.isApplicationValid = true
      var obj = result.obj.applicationDetails
      
      // サーバーから取得した患者情報オブジェクトを取得
      var fromPatient = obj.patientsData[0]

      // 施設紹介先からの遷移の場合は、医師名、事務担当者名、患者IDを繋ぎ込まない
      if(this.introduction){
        this.reqParams.doctorName = ""
        this.reqParams.clerkName = ""
        this.reqParams.patientId = ""
      }else{
        this.reqParams.doctorName = obj.doctorName
        this.reqParams.clerkName = obj.clerkName
        this.reqParams.patientId = fromPatient.patientId
      }
      
      // 患者情報
      this.reqParams.patientFamilyName = fromPatient.patientFamilyName
      this.reqParams.patientFirstName = fromPatient.patientFirstName
      this.reqParams.patientFamilyNameKana = fromPatient.patientFamilyNameKana
      this.reqParams.patientFirstNameKana = fromPatient.patientFirstNameKana
      this.reqParams.gender = fromPatient.gender
      this.reqParams.birthday = fromPatient.birthday ? fromPatient.birthday.replace(/\//g, "-") : ""

      this.changeanAlysisMethod()
    },
    getHstRequestDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getAnalysisDetailPOST: function(client) {
      return client.apis.externalAnalysis.getAnalysisDetailPOST({
        body:{
          receiptNumber:this.preReceiptNumber,
        }
      });
    },
    getAnalysisDetailPOSTSuccess: function(result) {
      this.isApplicationValid = true
      var obj = result.obj.requestDetails

      // 施設紹介先からの遷移の場合は、医師名、事務担当者名、患者ID、解析情報などの基本情報を繋ぎ込まない
      if(this.introduction){
        this.reqParams.doctorName = ""
        this.reqParams.clerkName = ""
        this.reqParams.patientId = ""

        // 基本情報を繋ぎ込まない
        this.reqParams.analysisMethod = ""
        this.reqParams.sleepwareG3Version = ""
        this.reqParams.reportFormat = ""
      }else{
        this.reqParams.doctorName = obj.doctorName
        this.reqParams.clerkName = obj.clerkName
        this.reqParams.patientId = obj.patientId

        // 基本情報
        this.reqParams.analysisMethod = obj.analysisMethod
        this.reqParams.sleepwareG3Version = obj.sleepwareG3Version
        this.reqParams.reportFormat = obj.reportFormat
      }
      

      // 患者情報
      this.reqParams.patientFamilyName = obj.patientFamilyName
      this.reqParams.patientFirstName = obj.patientFirstName
      this.reqParams.patientFamilyNameKana = obj.patientFamilyNameKana
      this.reqParams.patientFirstNameKana = obj.patientFirstNameKana
      this.reqParams.gender = obj.gender
      this.reqParams.birthday = obj.birthday ? obj.birthday.replace(/\//g, "-") : ""

      this.changeanAlysisMethod()
    },
    getAnalysisDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getHolterRequestDetailPOST: function(client) {
      debugger;
      return client.apis.internalHolter.getHolterRequestDetailPOST({
        body:{
          receiptNumber:this.preReceiptNumber,
        }
      });
    },
    getHolterRequestDetailPOSTSuccess: function(result) {
      this.isApplicationValid = true
      var obj = result.obj.applicationDetails

      // サーバーから取得した患者情報オブジェクトを取得
      var fromPatient = obj.patientsData[0]

      // 施設紹介先からの遷移の場合は、医師名、事務担当者名、患者IDを繋ぎ込まない
      if(this.introduction){
        this.reqParams.doctorName = ""
        this.reqParams.clerkName = ""
        this.reqParams.patientId = ""
      }else{
        this.reqParams.doctorName = obj.doctorName
        this.reqParams.clerkName = obj.clerkName
        this.reqParams.patientId = fromPatient.patientId
      }

      // 患者情報
      this.reqParams.patientFamilyName = fromPatient.patientFamilyName
      this.reqParams.patientFirstName = fromPatient.patientFirstName
      this.reqParams.patientFamilyNameKana = fromPatient.patientFamilyNameKana
      this.reqParams.patientFirstNameKana = fromPatient.patientFirstNameKana
      this.reqParams.gender = fromPatient.gender
      this.reqParams.birthday = fromPatient.birthday ? fromPatient.birthday.replace(/\//g, "-") : ""

      this.changeanAlysisMethod()
    },
    getHolterRequestDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    // お急ぎ便利用チェック時
    useExpressDelivery() {
      this.reqParams.urgentConvenience = this.urgentConvenience;
      this.reqParams.shortestReturnDate = this.calculateShortestReturnDate();
    },
    // お急ぎ便注意事項チェック時
    agreeExpressDeliveryPrecautions() {
      this.reqParams.shortestReturnDate = this.calculateShortestReturnDate();
    },
    // 最短出荷日の変更と算出
    calculateShortestReturnDate() {
      // 17時を超えると翌営業日起算
      var moreoverAddDay = 0;
      var comparedDateHour = new Date().getHours();
      
      let holiday = false;
      let baseDay = new Date();

      if(baseDay.getDay() == 0 || baseDay.getDay() == 6 || HOLIDAY_JP.between(baseDay, baseDay).length != 0){
        //土日または祝日の場合
        holiday = true;
      }else{
        let formatedDay = this.MM_hyp_dd(baseDay);
        if(PH_HOLIDAYS.everyyear.includes(formatedDay)){  //年末年始の場合
          holiday = true
        }else{
          formatedDay = this.yyyy_hyp_MM_hyp_dd(baseDay);
          if(PH_HOLIDAYS.irregular.includes(formatedDay)){  //PHILIPS特別休日の場合
            holiday = true
          }
        }
      }
      
      if(comparedDateHour >= closingTime && !holiday) {
        moreoverAddDay = 1;
      }

      //選択された解析方法のM_CHOICESのレコード取得
      var choiceAnalysisMethod = this.analysisMethodList.find((val) => {
        return this.reqParams.analysisMethod == val.value
      });
      //choiceAnalysisMethod取得できなかった場合のエラー回避
      if(!choiceAnalysisMethod){
        return ""
      }
      //返却日数取得（マスタの返却日数は当日含むため、設定された返却日数から当日分を引く）
      var returnDays = parseInt(choiceAnalysisMethod.label4, 10) - 1

      // 最短返却日に加える加算日を算出
      var businessDaysLater = 4;
      if(this.urgentConvenience && this.precautionsAgree) {
        // お急ぎ便は申請日を含んで2営業日後
        businessDaysLater = 1;
      } else if(returnDays) {
        // マスタに返却日数が登録している場合、その日数を使用
        businessDaysLater = returnDays;
      } else {
        // 通常は申請日を含んで5営業日後
        businessDaysLater = 4;
      }
      // 最短返却日を算出
      var calculatedShortestReturnDate = this.getBusinessDay(
        new Date(),
        businessDaysLater + this.includeToday + moreoverAddDay
      )
      // フォーマット
      var formattedShortestReturnDate = this.yyyy_sla_MM_sla_dd(calculatedShortestReturnDate);

      // 返却日が算出し直した最短返却可能日よりも前の日である場合は、返却日をリセット
      if(new Date(this.reqParams.returnDate) < new Date(formattedShortestReturnDate.replace(/\//g, "-")) ){
        this.reqParams.returnDate = "";
      }

      return formattedShortestReturnDate;
    },
    // SleepwareG3のバージョン 必須表示切り替え
    isRequireForG3() {
      switch(this.psgKind) {
        case "full":
          this.requireG3 = this.reqParams.analysisMethod == this.analysisMethod.standardManual || this.reqParams.analysisMethod == this.analysisMethod.expertReview;
          break;
        case "easy":
          this.requireG3 = this.reqParams.analysisMethod == this.analysisMethod.simplified_alice;
          break;
        default:
          this.requireG3 = false;
          break;
      }
    },
    // 申込み確定前 最短返却日チェック
    finallyCheckReturnDate() {
      var comparedDateHour = new Date().getHours();
      if(comparedDateHour >= closingTime) {
        var selectedDate = new Date(this.reqParams.returnDate);
        var calculatedShortestReturnDate = new Date(this.calculateShortestReturnDate().replace(/\//g, "-"));
        if(selectedDate < calculatedShortestReturnDate) {
          this.reqParams.returnDate = "";
          this.reqParams.shortestReturnDate = this.calculateShortestReturnDate();
          this.$dialog.alert({
            title: " ",
            message: "17時を過ぎましたので最短返却可能日が変更されました。<br/>返却日を再度設定して下さい。",
            onConfirm: () => {
              this.activeStep -= 3;
            }
          })
          return false;
        }
      }
      return true;
    },
  },
  data() {
    var psgKind = this.$route.params["id"];
    var preReceiptNumber = this.$route.params["receiptNumber"];
    var preKind = this.$route.params["kind"];
    var introduction = this.$route.params["introduction"];
    var analysisType = "";
    if (psgKind == "full") {
      analysisType = "フルPSG検査";
    } else if (psgKind == "easy") {
      analysisType = "簡易検査";
    }
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var userId = userInfo.id;
    var isDealer = roleId == role.role_dealer;
    var isSalesOffice = roleId == role.role_salesOffice;
    var isHospital = roleId == role.role_hospital;
    var isHonsha = roleId == role.role_headOffice;
    var isAdmin = roleId == role.role_admin;
    var includeToday = this.isBusinessDay(new Date()) ? 0 : 1;
    var winterHolidayStart = new Date('2022/12/22');
    var winterHolidayEnd = new Date('2023/01/07');
    var now = new Date();
    var serviceId = service.psg;
    return {
      role: role,
      UploadType:UploadType,
      choicesType:choicesType,
      extUserStatus: extUserStatus,
      analysisMethod:analysisMethod,
      userId: userId,
      belongsId:userInfo.belongsId,
      userInfo: userInfo,
      isDealer: isDealer,
      isSalesOffice: isSalesOffice,
      isHonsha: isHonsha,
      isAdmin: isAdmin,
      organizationModalActive: false,
      isHospitalAgree: !isDealer,
      isChecked: false,
      agreement: "",
      activeStep: 0,
      psgKind: psgKind,
      analysisType: analysisType,
      reqParams:{
        isNotHospital: !isHospital,
        fullFlag:psgKind == "full",
        hospitalName:isHospital ? userInfo.medicalInstitutionName + " " + userInfo.departmentName : "",
        doctorName:"",
        clerkName:"",
        isResultMailSend: false,
        hospitalMail:"",
        analysisMethod:"",
        sleepwareG3Version:"",
        reportFormat:"",
        returnDate: "",
        shortestReturnDate: "",
        urgentConvenience:false,
        urgentConvenienceReasons:"",
        deliverySlip:false,
        demo:false,
        patientId:"",
        patientName:"",
        patientNameKana:"",
        gender:"",
        birthday:"",
        japaneseCalendar:"",
        age:"",
        height:"",
        weight:"",
        bmi:"",
        basicIllnessComplications:"",
        dosingStatus:"",
        chiefComplaint:"",
        biko:"",
        patientBiko:"",
        institutionId: "",
        analysisDataInfo:{
          inspectionPurpose:"",
          inspectionPurposeMemo:"",
          setPressure:"",
          offTime:"",
          onTime:"",
          offTimeAdditionalInstructions:"",
          biko:"",
          attachedDataFileList:[]
        }
      },
      upFiles: [],
      upButtonFile:null,
      isUpdateModal: false,
      offTimeHour:"",
      offTimeMinutes:"",
      onTimeHour:"",
      onTimeMinutes:"",
      compleateFlg:false,
      requestDate:"",
      receiptNumber:"",
      precautionsAgree:false,
      officeCalenderActive: false,
      urgentConvenience:false,
      needAgree: isHospital || isDealer,
      canAgree:false,
      consentStatement:consentStatement,
      analysisMethodList:[],
      analysisMethodListLinkedEstimate:[],
      sleepwareVersionList:[],
      reportFormatList:[],
      inspectionPurposeList:[],
      offTimeAdditionalInstructionsList:[],
      reset: 0,
      includeToday: includeToday,
      requireG3:false,
      defaultMail: "",
      prevPsgSearchParam:{
        kind:this.$route.params["kind"]?this.$route.params["kind"]:'psg',
        belongsId:userInfo.belongsId,
        institutionId:0,
        fullFlag:this.$route.params["id"]?this.$route.params["id"]=='full'?true:false:psgKind == "full"
      },
      isHospital,
      winterHoliday: now >= winterHolidayStart.getTime() && now < winterHolidayEnd.getTime(),
      preReceiptNumber,
      preKind,
      introduction,
      note:"",
      serviceId,
      isApplicationValid: false,
    };
  },
  computed: {},
  components: {
    organizationSelectModal:OrganizationSelectModal,
    facilitySelectModal:FacilitySelectModal,
    psgRequestDetail: psgRequest,
    officeCalenderModal:OfficeCalenderModal
  },
  async mounted() {
    //同意文取得
    await this.getAgreementStr();
    // 機種マスタ取得
    await this.getChoicesList();
    if(this.isHospital){
      // 見積りコードが紐づいた解析方法を取得・設定
      await this.getChoicesListLinkedEstimate();
      if(this.preReceiptNumber) {
      	await this.getApplication();
      } else {
        // 前回申込み情報の取得
        await this.getPreviousApplication()
      }
    }
  }
};
</script>

<style>
</style>
<style lang="scss">
.urgency_caution {
  color: red;
  margin-left: 10px;
}
.uploadModal {
  width: 900px !important;
  height:500px !important;
  display: grid !important;
  place-items: center !important;
}
.hsrReq_upload_area {
  height: 60px !important;
  line-height: 30px;
  border: 2px dotted;
  text-align: center;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/PSGRequest.vue